import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["active", "children", "data-testid", "hasItems", "hoveredItem", "isOpen", "isPrimary", "navItem", "setHoveredItem"];
/* eslint-disable no-nested-ternary */
import React from 'react';
import { styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { renderSideNavItemIcon } from './renderSideNavItemIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SideNavButton(props) {
  var active = props.active,
    children = props.children,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    hasItems = props.hasItems,
    hoveredItem = props.hoveredItem,
    isOpen = props.isOpen,
    _props$isPrimary = props.isPrimary,
    isPrimary = _props$isPrimary === void 0 ? false : _props$isPrimary,
    navItem = props.navItem,
    setHoveredItem = props.setHoveredItem,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(StyledListItemButton, _extends({
    "aria-expanded": isOpen ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": typeof children === 'string' ? children : 'menu-item',
    className: active ? 'active' : undefined,
    "data-testid": testid,
    disableRipple: true,
    isHover: (hoveredItem == null ? void 0 : hoveredItem.key) === navItem.key,
    isPrimary: isPrimary,
    isVisible: !!(hoveredItem != null && hoveredItem.key),
    onMouseEnter: function onMouseEnter() {
      return setHoveredItem(navItem);
    },
    onMouseOver: function onMouseOver() {
      return setHoveredItem(navItem);
    }
  }, others, {
    "data-element": "StyledListItemButton",
    "data-component": "SideNavButton",
    "data-source-file": "SideNavButton.tsx",
    children: [/*#__PURE__*/_jsx(StyledListItemIcon, {
      isPrimary: isPrimary,
      "data-element": "StyledListItemIcon",
      "data-source-file": "SideNavButton.tsx",
      children: renderSideNavItemIcon(navItem.key, active, (hoveredItem == null ? void 0 : hoveredItem.key) === navItem.key)
    }), /*#__PURE__*/_jsx(StyledTypography, {
      isHover: (hoveredItem == null ? void 0 : hoveredItem.key) === navItem.key,
      isVisible: !!(hoveredItem != null && hoveredItem.key),
      "data-element": "StyledTypography",
      "data-source-file": "SideNavButton.tsx",
      children: children
    }), hasItems && /*#__PURE__*/_jsx(StyledArrowIcon, {
      isHover: false,
      isVisible: !!(hoveredItem != null && hoveredItem.key),
      children: /*#__PURE__*/_jsx(ArrowForwardIosIcon, {
        sx: {
          height: '12px',
          minWidth: 'inherit',
          width: '12px'
        }
      })
    })]
  }));
}
var StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary';
  }
})(function (_ref) {
  var isPrimary = _ref.isPrimary,
    theme = _ref.theme;
  return {
    color: theme.palette.grey[isPrimary ? 600 : 500],
    marginRight: isPrimary ? 8 : 0,
    minWidth: 24
  };
});
var StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary' && props !== 'isHover' && props !== 'isVisible';
  }
})(function (_ref2) {
  var isPrimary = _ref2.isPrimary,
    isVisible = _ref2.isVisible,
    theme = _ref2.theme;
  return {
    '&.active': {
      '& .MuiTypography-root': {
        color: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
      },
      '&:hover': {
        '& .MuiTypography-root': {
          color: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
        }
      },
      backgroundColor: isPrimary ? theme.palette.primary[50] : theme.palette.common.white
    },
    '&:first-of-type': {
      marginTop: isPrimary ? 0 : 16
    },
    '&:hover': {
      '& .MuiTypography-root': {
        color: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
      }
    },
    '&:not(&:first-of-type)': {
      marginTop: isPrimary ? 8 : 16
    },
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'row',
    fontSize: '14px',
    justifyContent: isPrimary ? 'left' : 'center',
    maxHeight: isPrimary ? 48 : 40,
    overflow: 'hidden',
    padding: isPrimary ? '0 13px' : '0 10px',
    textAlign: 'center',
    width: isPrimary ? '100%' : !isPrimary && !isVisible ? '40px' : '240px'
  };
});
var StyledTypography = styled(Typography, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary' && props !== 'isHover' && props !== 'isVisible';
  }
})(function (_ref3) {
  var isHover = _ref3.isHover,
    isPrimary = _ref3.isPrimary,
    isVisible = _ref3.isVisible,
    theme = _ref3.theme;
  return {
    color: isHover ? theme.palette.primary.main : !isPrimary && isHover ? theme.palette.grey[700] : theme.palette.grey[600],
    display: isVisible ? 'block' : 'none',
    fontSize: '14px',
    marginLeft: isPrimary ? 0 : 10,
    textAlign: 'left',
    width: '100%'
  };
});
var StyledArrowIcon = styled(ListItemIcon, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isVisible' && props !== 'isHover';
  }
})(function (_ref4) {
  var isVisible = _ref4.isVisible,
    theme = _ref4.theme;
  return {
    display: isVisible ? 'block' : 'none',
    marginRight: '-5px',
    minWidth: 'inherit'
  };
});